export default [
    {
        path: 'clans',
        component: () => import('@/pages/isle/clan/clans')
    },
    {
        path: 'my-clan',
        component: () => import('@/pages/isle/clan/my')
    },
    {
        path: 'member-list',
        component: () => import('@/pages/isle/clan/member')
    },
    {
        path: 'clan-admin',
        component: () => import('@/pages/isle/clan/admin')
    },
    {
        path: 'clan-inv',
        component: () => import('@/pages/isle/clan/repos')
    },
    {
        path: 'dynamic-list',
        component: () => import('@/pages/isle/clan/dynamic')
    },{
        path: 'req-logs',
        component: () => import('@/pages/isle/clan/rep-logs')
    }
];